import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './WindowBox.css';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
// import crossImg from 'components/cross.svg';

export default class WindowBox extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.hasVerticalScroll();
    // this.toggleBodyVisible('hidden');
  }

  componentWillUnmount() {
    this.toggleBodyVisible('visible');
  }

  // scrollbar hidden when WindowBox show
  toggleBodyVisible(param) {
    const getBody = document.getElementsByTagName('body')[0];
    const getNavbar = document.getElementById('navbar');
    const getWinBoxs = document.getElementsByClassName('new-window-container');
    if (getWinBoxs.length === 1) {
      getBody.style.overflow = param;
    }
    if (param === 'hidden') {
      getBody.style.paddingRight = '16px';
      getNavbar.style.paddingRight = '16px';
    } else {
      getBody.style.paddingRight = '0px';
      getNavbar.style.paddingRight = '0px';
    }
  }

  hasVerticalScroll() {
    if (window.innerHeight) {
      if (document.body.offsetHeight > innerHeight) {
        this.toggleBodyVisible('hidden');
        return;
      }
    } else {
      if (document.documentElement.scrollHeight > document.documentElement.offsetHeight ||
      document.body.scrollHeight > document.body.offsetHeight) {
        this.toggleBodyVisible('hidden');
        return;
      }
    }
    return;
  }

  renderLayerPostion(layer) {
    // if input value isn't number (false), return;
    if (/[^0-9]/.test(layer)) {
      return {};
    }
    // basicMargin + ((headHeight + spacing) * layer)
    const top = 60 + ((40 + 5) * layer);
    // spacing * layer
    const left = 15 * layer;
    return {
      marginTop: `${top}px`,
      left: `calc(50% + ${left}px)`,
    };
  }

  render() {
    const {
      title, // set WindowBox title
      onClose, // set WindowBox close function
      onConfirm, // set WindowBox 確認 button function
      onCancel, // set WindowBox 取消 button function
      width, // set WindowBox width
      height, // set WindowBox height
      layer,
      center,
      newcss,
      newWin,
      titleBackgroundColor,
      containerStyle,
      disabled,
      confirmText,
      confirmDisabled,
    } = this.props;
    const layerNum = parseInt(layer, 10);
    let modalStyle = null;
    if (layerNum > 0) {
      modalStyle = {
        backgroundColor: 'transparent',
      };
    }
    let boxStyle = {
      width: width ? width : 600,
      height: height ? height : 'auto',
    };
    boxStyle = Object.assign(boxStyle, this.renderLayerPostion(layerNum));

    return (
      <div className={cx('new-window-container', { 'is-center': center, 'new': newcss, newWin })} style={modalStyle}>
        <div
          className="new-window"
          style={boxStyle}
        >
          <div
            className="new-window-title"
            style={{
              backgroundColor: titleBackgroundColor ? titleBackgroundColor : '#131c39',
            }}
          >
            <h1>{title}</h1>
            <button className="btn new-window-title-button" onClick={onClose} disabled={disabled}>
              {/* <img src={crossImg} width="20px" height="20px"/> */}
              <span className="fa-stack fa-lg" style={{ width: '18px', height: '18px', 'lineHeight': '18px' }}>
                <i className="fa fa-circle fa-stack-1x fa-inverse py_window_inverse" style={{ color: titleBackgroundColor ? titleBackgroundColor : '#131c39', fontSize: '1.2em' }}></i>
                <i className="fa fa-circle fa-stack-1x" style={{ color: 'rgba(255, 255, 255, 0.5)' }}></i>
                <i className="fa fa-times fa-stack-1x" style={{ color: titleBackgroundColor ? titleBackgroundColor : '#131c39', fontSize: '0.59em' }}></i>
              </span>
            </button>
          </div>
          <div className="new-window-body clearfix" style={containerStyle}>
            {this.props.children}
          </div>
          <div className="new-window-actions clearfix" style={{ borderTop: '1px solid #eee', padding: '6px 10px', textAlign: 'right' }}>
            {
              onConfirm && (
                <button type="button" className="btn btn-default" onClick={onConfirm} disabled={disabled || confirmDisabled}>
                  {
                    confirmText ? confirmText :
                    <FormattedMessage
                      id="SH_Confirm"
                      defaultMessage="確定"
                    />
                  }
                </button>
              )
            }
            {
              onCancel && (
                <button type="button" className="btn btn-default" onClick={onCancel} disabled={disabled}>
                  <FormattedMessage
                    id="SH_Cancel"
                    defaultMessage="取消"
                  />
                </button>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

WindowBox.propTypes = {
  title: PropTypes.any,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  containerStyle: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  layer: PropTypes.string,
  center: PropTypes.bool,
  newcss: PropTypes.bool,
  newWin: PropTypes.bool,
  disabled: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  confirmText: PropTypes.string,
  titleBackgroundColor: PropTypes.string,
};

WindowBox.defaultProps = {
  title: '',
  layer: '0',
  center: false,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/components/WindowBox/index.js
 **/